import { Injectable, inject } from '@angular/core';

import { AUTH_SESSION } from '@the-hive-frontend/auth-session';
import { firstValueFrom } from 'rxjs';

import { ClientStore } from './client.store';
import { TenantStore } from './tenant.store';
import { AuthService, ClientUserError } from '../services/auth.service';

@Injectable({ providedIn: 'root' })
export class AuthStore {
  private readonly session = inject(AUTH_SESSION);
  private readonly authApi = inject(AuthService);
  private readonly clientStore = inject(ClientStore);
  private readonly tenantStore = inject(TenantStore);

  async login(): Promise<void> {
    await this.session.signIn();
    await this.verifyClientUser();
    await this.tenantStore.init();
    await this.clientStore.init();
  }

  async logout(): Promise<void> {
    await this.clientStore.clear();
    await this.tenantStore.clear();
    await this.session.signOut();
  }

  async getAccessToken(): Promise<string | null> {
    return this.session.getAccessToken();
  }

  private async verifyClientUser(): Promise<void> {
    const user = await firstValueFrom(this.authApi.getCurrentUser());
    if (!user.data.clientUser) {
      await this.clientStore.clear();
      await this.tenantStore.clear();
      await this.session.signOut();
      throw new ClientUserError();
    }
  }
}
